module.exports = __webpack_public_path__ + "img/search.36fd7395.svg";